import { PoweredBy, ProgressStepper } from "@justhome/react-ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface ProgressIndicatorProps {
  steps: number;
  currentStep: number;
}

const ProgressIndicator: FC<ProgressIndicatorProps> = ({
  steps,
  currentStep,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="bg-neutral-25 h-2xs rounded-xs relative">
        <ProgressStepper currentStep={currentStep} steps={steps + 1} />
      </div>
      <div className="flex justify-between mt-xs">
        <span className="text-body-2 text-neutral-150">
          {currentStep <= steps && (
            <>
              {t("common.step")} {currentStep} {t("common.of")} {steps}
            </>
          )}
          {currentStep > steps && t("common.results")}
        </span>
        <PoweredBy />
      </div>
    </div>
  );
};

export default ProgressIndicator;
